import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/HomepageStatic/CapitalMarketsStatic";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const CapitalMarketsStaticTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="CapitalMarketsStatic">
      <TabletNotice page="CapitalMarketsStatic" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default CapitalMarketsStaticTablet;